<template>
<div class="row">
  <div class="col-12 py-0 flex-row">
    <v-btn icon @click="$router.go(-1)">
      <i class="fa-solid fa-arrow-right fa-xl pointer"></i></v-btn>
    <h1 class="primary-text d-inline-block">{{title}}</h1>
  </div>
</div>
</template>

<script>
export default {
  name: "BackBar",
  props:['title']
}
</script>

<style scoped>

</style>